export const CONNECTION_ERROR_MSG = 'Something went wrong. Please check your internet connection and try again.'

export const getSafeErrorString = (error: unknown, key: string): string | undefined => {
  if (!error || (typeof error !== 'object' && typeof error !== 'function')) return undefined

  try {
    const value = Reflect.get(error, key)
    return typeof value === 'string' ? value : undefined
  } catch {
    return undefined
  }
}

export const isDOMExceptionGetterCrash = (error: unknown) => {
  const message = getSafeErrorString(error, 'message')
  return error instanceof TypeError && message?.includes('DOMException.message getter can only be used on instances of DOMException')
}
